import { api } from './api';

const PLATFORM_SAAS_BILLING_OPERATIONS_BASE = '/api/platform-admin/saas-billing/operations';

const buildQueryParams = (params = {}) => {
  const query = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === '') {
      return;
    }
    query[key] = value;
  });
  return query;
};

export const platformSaasBillingOperationsService = {
  resolvePaymentCase: async (params = {}) => {
    const response = await api.get(`${PLATFORM_SAAS_BILLING_OPERATIONS_BASE}/payment-cases/resolve`, {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getPaymentCaseTimeline: async (params = {}) => {
    const response = await api.get(`${PLATFORM_SAAS_BILLING_OPERATIONS_BASE}/payment-cases/timeline`, {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  listWebhookEvents: async (params = {}) => {
    const response = await api.get(`${PLATFORM_SAAS_BILLING_OPERATIONS_BASE}/webhook-events`, {
      params: buildQueryParams(params),
    });
    return response.data;
  },
};

export default platformSaasBillingOperationsService;